let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("izTIP")).then(() => parcelRequire('gaa8P'));